// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__I5WRC","inner":"Form_inner__2IEcB","range":"Form_range__2HBXG","name":"Form_name__2yt02","actions":"Form_actions__3gNgd"};